import { render, staticRenderFns } from "./equipmentCard.vue?vue&type=template&id=e37a38a2&scoped=true&"
import script from "./equipmentCard.vue?vue&type=script&lang=js&"
export * from "./equipmentCard.vue?vue&type=script&lang=js&"
import style0 from "./equipmentCard.vue?vue&type=style&index=0&id=e37a38a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37a38a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e37a38a2')) {
      api.createRecord('e37a38a2', component.options)
    } else {
      api.reload('e37a38a2', component.options)
    }
    module.hot.accept("./equipmentCard.vue?vue&type=template&id=e37a38a2&scoped=true&", function () {
      api.rerender('e37a38a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/constructionEquipmentMgr/stockMgr/mobile/components/equipmentCard.vue"
export default component.exports